import {
    replaceInChain,
} from "@insite/client-framework/HandlerCreator";
import { Session, updateSession } from "@insite/client-framework/Services/SessionService";
import { chain, DispatchBeginUpdateBillTo, UpdateSession } from "@insite/client-framework/Store/Pages/OnePageCheckout/Handlers/UpdateBillTo";

type XcUpdateBillToProps = Parameters<typeof DispatchBeginUpdateBillTo>[0];

async function XcUpdateSession(props: XcUpdateBillToProps) {
    const properties: { [key: string]: string } = {};
    properties["DoNotUpdateShipTo"] = "true";
    await updateSession({
        session: {
            billToId: props.parameter.billTo.id,
            shipToId: props.defaultShipTo.id,
            customerWasUpdated: true,
            properties
        } as Session,
    });
}
replaceInChain(chain, UpdateSession, XcUpdateSession);